//@flow
import React, { Component } from 'react';
import { type TableRowOptionProps } from '../..';
import { Device } from '../../../Responsive';
import { CustomModelListTd } from '../../StatisticsStyles';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  tableRowOptions: TableRowOptionProps
};

export default class TableRowDeviceRow1 extends Component<Props> {
  render() {
    return (
      <>
        <DefaultModelRowTr>
          {this.props.tableRowOptions.device.row1.map((item, i) => (
            <React.Fragment key={i}>
              <Device>
                <CustomModelListTd right={item.right} noBorder first bold>
                  {item.value}
                </CustomModelListTd>
              </Device>
            </React.Fragment>
          ))}
        </DefaultModelRowTr>
      </>
    );
  }
}
